import { Box } from "@mui/material";
import AboutUsComponent from "../components/AboutUsComponent";
import Header from "../core/Header";
import Footer from "../core/Footer";
import PageHero from "../components/PageHero";
import { useTranslation } from "../utils/i18n";

function AboutPage() {
  const { translations } = useTranslation();
  const ab = translations.aboutPage;

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#F6F7F9",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header />
      <PageHero
        overline={ab.overline}
        title={ab.title}
        subtitle={ab.subtitle}
      />
      <AboutUsComponent />
      <Footer />
    </Box>
  );
}

export default AboutPage;
